import { useQuery } from '@tanstack/react-query'
import { useAxios } from 'packages/core'

export const useModalSearchForAssignmentPopup = (
    url,
    queryFilters,
    enableApi,
) => {
    const callApi = useAxios()
    const queryData = { ...queryFilters }
    return useQuery(
        [`MODAL_SEARCH_KEY_UnAssigned`, queryData, url, enableApi],
        (skip) => {
            return callApi({
                url: url,
                method: 'POST',
                data: {
                    ...queryData,
                },
            })
        },
        { enabled: enableApi, cacheTime: 0 },
        // using defaultTake param and removing above from data
        queryData?.take ? queryData.take : 5,
        {
            variant: 'rounded',
            siblingCount: 0,
            showPageSelection: false,
            showItemsPerPageSelection: false,
        },
    )
}
